import Success from '@/assets/image/message-status/success.svg';
import Info from '@/assets/image/message-status/info.svg';
import Warning from '@/assets/image/message-status/warning.svg';
import Error from '@/assets/image/message-status/error.svg';


interface MessageConfig {
  id?: string;
  message: string;
  position?: 'top' | 'center';
  duration?: number;
  showIcon?: boolean;
  icon?: any;
};

type Config = MessageConfig;
type MessageType = 'info' | 'success' | 'warning' | 'error';
type MessageDict = { id: string, message: string, [other:string]: any }[];
class Message {
  // private messageDict: MessageDict = [];
  private static MessageInstance: Message | null = null;


  static getInstance() {
    if (!this.MessageInstance) {
      this.MessageInstance = new Message();
    }
    return this.MessageInstance;
  }

  private build(type: MessageType, config: Config) {
    config.position = config.position ?? 'top';
    config.duration = config.duration ?? 3000;
    config.showIcon = config.showIcon ?? true;
    if (type === 'info') {
      config.icon = Info;
    } else if (type === 'success') {
      config.icon = Success;
    } else if (type === 'warning') {
      config.icon = Warning;
    } else if (type === 'error') {
      config.icon = Error;
    };
    // const isExistIndex = this.messageDict.findIndex((dict) => dict.id === config.id);
    // const isNew = isExistIndex < 0;
    // if (isNew) {
    //   this.messageDict.push({
    //     ...config,
    //   });
    // } else {
    //   this.messageDict[isExistIndex] = config;
    // };
    this.execute(config);
  };

  private async sleep(duration: number) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(duration);
      }, duration);
    })
  }

  private async execute(config: Config) {
    const { id, message, position, duration, showIcon, icon } = config;

    const messageWrap = document.createElement('div');
    messageWrap.classList.add('cyy_toast')
    const messageDom = document.createElement('div');
    messageDom.innerHTML = message;
    if (showIcon) {
      const imgDom = document.createElement('img');
      imgDom.src = icon;
      messageWrap.appendChild(imgDom);
    };
    messageWrap.appendChild(messageDom);
    const messageWrapLen = document.getElementsByClassName('cyy_toast').length;

    let top = null;
    if (position === 'top') {
      top = ((messageWrapLen * 45) + 30) + 'px';
    } else {
      top = '50%';
    }
    messageWrap.style.top = top;

    document.body.appendChild(messageWrap);
    await this.sleep(duration!);
    if (top !== '30px') {
      messageWrap.style.top = '30px';
    } else {
      messageWrap.style.top = '-99999999px';
    }
    await this.sleep(600);
    document.body.removeChild(messageWrap);
  }


  info(config: Config) {
    this.build('info', config);
  }

  success(config: Config) {
    this.build('success', config);
  }

  warning(config: Config) {
    this.build('warning', config);
  }

  error(config: Config) {
    this.build('error', config);
  }
}

export default Message.getInstance();
